import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Cloud, Droplets, Wind, Sun, CloudRain, CloudSnow, CloudFog } from "lucide-react";

// Open-Meteo WMO code -> label + icon
const CODE_MAP = {
  0: { l: "साफ़ आसमान", Icon: Sun },
  1: { l: "अधिकतर साफ़", Icon: Sun },
  2: { l: "आंशिक बादल", Icon: Cloud },
  3: { l: "बादल छाए", Icon: Cloud },
  45: { l: "कोहरा", Icon: CloudFog },
  48: { l: "कोहरा", Icon: CloudFog },
  51: { l: "हल्की बूंदाबांदी", Icon: CloudRain },
  53: { l: "बूंदाबांदी", Icon: CloudRain },
  55: { l: "तेज़ बूंदाबांदी", Icon: CloudRain },
  61: { l: "हल्की बारिश", Icon: CloudRain },
  63: { l: "बारिश", Icon: CloudRain },
  65: { l: "भारी बारिश", Icon: CloudRain },
  71: { l: "हल्की बर्फ़", Icon: CloudSnow },
  73: { l: "बर्फ़बारी", Icon: CloudSnow },
  80: { l: "बौछारें", Icon: CloudRain },
  95: { l: "आँधी-तूफ़ान", Icon: CloudRain },
};

export default function WeatherStrip() {
  const [w, setW] = useState(null);
  useEffect(() => { api.get("/weather").then((r) => setW(r.data)).catch(() => {}); }, []);
  if (!w || !w.current || w.current.temperature_2m == null) return null;

  const code = w.current.weather_code;
  const info = CODE_MAP[code] || { l: "मौसम", Icon: Cloud };
  const { Icon } = info;
  const max = w.daily?.temperature_2m_max?.[0];
  const min = w.daily?.temperature_2m_min?.[0];

  return (
    <div className="bg-slate-100 border-b border-slate-200" data-testid="weather-strip">
      <div className="max-w-7xl mx-auto px-4 py-1.5 flex items-center gap-4 text-xs font-admin overflow-x-auto whitespace-nowrap">
        <div className="flex items-center gap-1.5">
          <Icon className="w-4 h-4 text-[#EA580C]"/>
          <span className="font-semibold text-slate-800">{w.location}</span>
        </div>
        <span className="text-slate-400">·</span>
        <span className="text-slate-700"><span className="font-bold text-[#0F172A]">{Math.round(w.current.temperature_2m)}°C</span> {info.l}</span>
        {max != null && <><span className="text-slate-400">·</span><span className="text-slate-600">अधिकतम {Math.round(max)}° / न्यूनतम {Math.round(min)}°</span></>}
        {w.current.relative_humidity_2m != null && <><span className="text-slate-400 hidden sm:inline">·</span><span className="text-slate-600 hidden sm:inline-flex items-center gap-1"><Droplets className="w-3 h-3"/>{w.current.relative_humidity_2m}%</span></>}
        {w.current.wind_speed_10m != null && <><span className="text-slate-400 hidden sm:inline">·</span><span className="text-slate-600 hidden sm:inline-flex items-center gap-1"><Wind className="w-3 h-3"/>{Math.round(w.current.wind_speed_10m)} km/h</span></>}
      </div>
    </div>
  );
}
